module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable.li",
      value: (_vm.reorderGroup),
      expression: "reorderGroup",
      modifiers: {
        "li": true
      }
    }],
    staticClass: "mdlext-accordion mdlext-accordion--vertical",
    attrs: {
      "id": "groups"
    }
  }, [_vm._l((_vm.cprop_groups.getEmbeds('client_property_groups')), function(group, g_idx) {
    return _c('li', {
      key: group.uid,
      staticClass: "mdlext-accordion__panel",
      attrs: {
        "id": group.uid,
        "data-order": g_idx
      }
    }, [_c('header', {
      staticClass: "mdlext-accordion__tab"
    }, [_c('span', {
      staticClass: "mdlext-accordion__tab__caption"
    }, [_c('span', {
      staticClass: "button-group-fab"
    }, [_vm._m(0, true, false), _c('v-icon-toggle-button', {
      on: {
        "clicked": function($event) {
          _vm.toggleShowGroup(group.uid)
        }
      }
    })], 1), _c('span', [_vm._v(_vm._s(group.name))]), _c('span', {
      staticClass: "button-group-fab right"
    }, [_c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.editGroup(group)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("edit")])]), _c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.deleteGroup(group)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])])]), _c('section', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.toggle.groups[group.uid]),
        expression: "toggle.groups[group.uid]"
      }],
      staticClass: "mdlext-accordion__tabpanel"
    }, [_c('ul', {
      directives: [{
        name: "sortable",
        rawName: "v-sortable.li",
        value: (_vm.reorderProperty),
        expression: "reorderProperty",
        modifiers: {
          "li": true
        }
      }],
      staticStyle: {
        "list-style": "none"
      },
      attrs: {
        "id": 'properties_for_' + group.uid,
        "data-g_uid": group.uid
      }
    }, _vm._l((group.getEmbeds('client_property_definitions')), function(prop, p_idx) {
      return _c('li', {
        key: prop.uid,
        staticClass: "prop",
        attrs: {
          "id": 'property_' + prop.uid,
          "data-order": p_idx,
          "data-g_uid": group.uid,
          "data-p_uid": prop.uid
        }
      }, [_c('span', {
        staticClass: "button-group-fab"
      }, [_vm._m(1, true, false), _c('v-icon-toggle-button', {
        on: {
          "clicked": function($event) {
            _vm.toggleShowOptions(prop.uid)
          }
        }
      })], 1), _c('span', [_vm._v(_vm._s(prop.label))]), _c('span', {
        staticClass: "button-group-fab right"
      }, [_c('button', {
        staticClass: "mdl-button mdl-button--icon",
        on: {
          "click": function($event) {
            _vm.editProperty(prop)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("edit")])]), _c('button', {
        staticClass: "mdl-button mdl-button--icon",
        on: {
          "click": function($event) {
            _vm.deleteProperty(prop)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("delete forever")])])]), _c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.toggle.options[prop.uid]),
          expression: "toggle.options[prop.uid]"
        }, {
          name: "sortable",
          rawName: "v-sortable.li",
          value: (_vm.reorderOption),
          expression: "reorderOption",
          modifiers: {
            "li": true
          }
        }],
        staticStyle: {
          "list-style": "none"
        },
        attrs: {
          "id": 'options_for_' + prop.uid
        }
      }, _vm._l((prop.getEmbeds('client_property_option')), function(option, o_idx) {
        return _c('li', {
          key: option.uid,
          staticClass: "opt",
          attrs: {
            "id": 'option_' + option.uid,
            "data-order": o_idx,
            "data-g_uid": group.uid,
            "data-p_uid": prop.uid
          }
        }, [_vm._m(2, true, false), _c('span', [_vm._v(_vm._s(option.value))]), _c('span', {
          staticClass: "right"
        }, [_c('button', {
          staticClass: "mdl-button mdl-button--icon",
          on: {
            "click": function($event) {
              _vm.editOption(group, prop, option)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])]), _c('button', {
          staticClass: "mdl-button mdl-button--icon",
          on: {
            "click": function($event) {
              _vm.deleteOption(group, prop, option)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])])])
      })), _c('button', {
        staticClass: "mdl-button mdl-js-button mdl-button--icon",
        attrs: {
          "onClick": "return false"
        },
        on: {
          "click": function($event) {
            _vm.addOption(group, prop)
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("add")])])])
    })), _c('button', {
      staticClass: "mdl-button mdl-js-button mdl-button--icon",
      attrs: {
        "onClick": "return false"
      },
      on: {
        "click": function($event) {
          _vm.addProperty(group)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("add")])])])])
  }), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--icon",
    attrs: {
      "onClick": "return false"
    },
    on: {
      "click": function($event) {
        _vm.addGroup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])])], 2), _c('v-dialog-property-group-edit', {
    attrs: {
      "id": "edit_group",
      "group": _vm.edit_group
    },
    on: {
      "ok": function($event) {
        _vm.updateGroup($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-property-group-add', {
    attrs: {
      "id": "add_group"
    },
    on: {
      "ok": function($event) {
        _vm.newGroup($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-confirm', {
    attrs: {
      "id": "confirm",
      "message": _vm.show.message
    },
    on: {
      "ok": function($event) {
        _vm.show.action()
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-property-edit', {
    attrs: {
      "id": "edit_prop",
      "prop": _vm.edit_prop,
      "types": _vm.types
    },
    on: {
      "ok": function($event) {
        _vm.updateProperty($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-property-add', {
    attrs: {
      "id": "add_prop",
      "group": _vm.add_to_group,
      "types": _vm.types
    },
    on: {
      "ok": function($event) {
        _vm.newProperty($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-option-add', {
    attrs: {
      "id": "add_option",
      "prop": _vm.edit_prop,
      "group": _vm.edit_group
    },
    on: {
      "ok": function($event) {
        _vm.newOption($event)
      },
      "cancel": _vm.cancel
    }
  }), _c('v-dialog-option-edit', {
    attrs: {
      "id": "edit_option",
      "prop": _vm.edit_prop,
      "group": _vm.edit_group,
      "option": _vm.edit_option
    },
    on: {
      "ok": function($event) {
        _vm.updateOption($event)
      },
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "button-group-fab"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4612a575","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administration/Properties.vue
// module id = 514
// module chunks = 1